import { useEffect, useState } from "react";
import { LinkedModelCard } from "./linkedModelCard";
import { LinkedModelView } from "../../../eventBus/linkedModelsEventPayloads";
import eventBus, { IApplicationEvent } from "../../../eventBus/eventDispatcher";
import "./linkedModelCard.css";

export const LinkedModelList = () => {
    const [linkedModels, setLinkedModels] = useState<LinkedModelView[]>([]);

    useEffect(() => {
        const onModelsLoaded = (event: IApplicationEvent<LinkedModelView[]>) => {
            setLinkedModels(event.payload);
        };

        eventBus.addEventListener("Dextall.LinkedModels.Loaded", onModelsLoaded);

        return () => {
            eventBus.removeEventListener("Dextall.LinkedModels.Loaded", onModelsLoaded);
        };
    }, []);

    const onActivateLinkedModel = (model: LinkedModelView) => {
        eventBus.dispatchEvent({ type: "Dextall.LinkedModels.UI.Highlight", payload: model.id });
    };

    return (
        <div className="linked-model-list">
            {linkedModels.map(model => (
                <LinkedModelCard key={model.id} model={model} controlsEnabled onSelect={onActivateLinkedModel} />
            ))}
        </div>
    );
};
